<app-page>
    <app-location [locationId]="locationId" *ngIf="locationId"></app-location>
</app-page>
